import React, { useState, useContext } from "react";
import * as style from "./style.mod.scss";
import { Container } from "react-bootstrap";
import GlobalContext from "services/global-context";
import getImagePath from "helpers/get-image-path";
import {
  Formik, Field, Form, ErrorMessage
} from "formik";
import locale from "locales";
import BlueArrowRight from "assets/images/icons/blue-transparent.svg";
import { loadRecaptcha } from "helpers/load-recaptcha";
import * as Yup from "yup";

const EmailSchema = Yup.object().shape({
  email: Yup.string()
    .email(locale.login.invalidEmail)
    .required(locale.login.invalidEmail)
    .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, locale.login.invalidEmail)
});

const PrivateSaleSignUp = ({ data }) => {
  const { privateSaleImage, id } = data;
  const { fullHeight } = useContext(GlobalContext);
  const [disabled, setDisabled] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubscribe = async ({ email }) => {
    setDisabled(true);
    window.grecaptcha.ready(async function () {
      await window.grecaptcha.execute(process.env.GATSBY_RECAPTCHA_SITE_KEY, { action: "submit" });

      const response = await fetch("/.netlify/functions/klaviyo",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            email: email,
            listId: id
          })
        }
      );

      if (response?.status === 204) {
        setSuccess(true);
      }
      setDisabled(false);
    });
  };

  return (
    <div className={`${style.privateSaleSignUpContainer} ${fullHeight ? style.fullSignUpHeight : style.reducedSignUpHeight  }`}>
      <Container className={style.imageFormContainer}>
        <div className={style.leftSide}>
          <img src={getImagePath(privateSaleImage)} alt={privateSaleImage.alt} />
        </div>
        <div className={style.rightSide}>
          <h3>{locale.privateSale.deal}</h3>
          <p>
            {locale.privateSale.securePassword}
          </p>
          {success ?
            (<div className={style.success}>
              <img src={BlueArrowRight} alt="blue tick" />
              <p>{locale.privateSale.thankYou}</p>
            </div>) :
            (<Formik initialValues={{ email: "" }} onSubmit={handleSubscribe} validationSchema={EmailSchema}>
              <Form>
                <div className={style.emailButtonContainer}>
                  <Field className={style.email} name="email" onFocus={loadRecaptcha} placeholder={locale.footer.yourEmail} />
                  <button type="submit" disabled={disabled} className={style.submitButton}>
                    <p>{locale.privateSale.getPassword}</p>
                  </button>
                </div>
                <div className={style.errorMessage}>
                  <ErrorMessage name="email" />
                </div>
              </Form>
            </Formik>)}
        </div>
      </Container>
    </div>
  );
};

export default PrivateSaleSignUp;
